import React from 'react';
import LocationTemplate from './LocationTemplate';

const GarysburgPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Garysburg"
      stateName="North Carolina"
      countyName="Northampton"
      zipCodes={["27831"]}
      latitude={36.4518}
      longitude={-77.5592}
      population={1111}
      historicalFact="Founded in 1906, named after railroad conductor W.R. Gary who helped establish the town."
      nearbyTowns={[
        "Roanoke Rapids, NC",
        "Weldon, NC",
        "Jackson, NC",
        "Seaboard, NC",
        "Gaston, NC",
        "Conway, NC",
        "Halifax, NC",
        "Emporia, VA"
      ]}
    />
  );
};

export default GarysburgPage;